import React from 'react';
import { siteContent } from '../data/mock';
import { X } from 'lucide-react';

export const NotForYou = () => {
  const { notForYou } = siteContent;

  return (
    <section className="bg-stone-50 border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="max-w-sm">
          <p className="font-medium text-stone-700 text-sm">{notForYou.title}</p>
          <ul className="mt-2 space-y-1">
            {notForYou.items.map((item, index) => (
              <li key={index} className="flex items-start gap-2">
                <X className="w-4 h-4 text-stone-400 mt-0.5 flex-shrink-0" />
                <span className="text-xs text-stone-500">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
